import { gql } from '@apollo/client';

const GET_ORGS_WITH_ACTIVE_UNITS = gql`
  query GetOrgsWithActiveUnits($eventType: Int) {
    orgsWithActiveUnits(eventType: $eventType) {
      Id
      Name
      MddapOrgUnits {
        Id
        Name
        Fei
        IsActive
      }
    }
  }
`;

export default GET_ORGS_WITH_ACTIVE_UNITS;
